module.exports = __webpack_public_path__ + "static-portal/img/53-1.41ca525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/53-1.jpg
// module id = 6c6N
// module chunks = 4